import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';

export const ukBankAccountStatusQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.UK.bankAccountStatus,
    queryFn: API.UK.me.getBankAccountStatus,
  });
